import { memo } from 'react'
import { isEqual } from 'lodash'
import { PageTitle } from 'app/components/common/PageTitle'
import R from 'app/assets/R'
import { useTranslation } from 'react-i18next'
import TreatmentPlanContainer from 'app/containers/DentalTreatmentManagement/TreatmentPlan'

const TreatmentPlanPageCpn = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageTitle>{t(R.strings.treatment_plan)}</PageTitle>
      <TreatmentPlanContainer />
    </>
  )
}
const TreatmentPlanPage = memo(TreatmentPlanPageCpn, isEqual)

export default TreatmentPlanPage
